<template>
  <v-app id="main">
    <v-navigation-drawer
      v-model="drawer"
      app
      color="black"
      clipped
    >
      <v-list dense>
        <!-- top -->
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="me.Profile && me.Profile.AvatarUrl"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item
          link
          to="/me/profile"
        >
          <v-list-item-content>
            <v-list-item-title
              class="title"
              style="line-height: 1;"
            >{{me && me.Profile && me.Profile.Name || ''}}</v-list-item-title>
            <v-list-item-subtitle>{{me.Username}}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon small>mdi-settings</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-divider class="mt-4 mb-4"></v-divider>

        <!-- 首頁 -->
        <!-- <v-list-item
          link
          to="/main/"
        >
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>首頁</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <!-- 公告 -->
        <v-list-item
          link
          to="/announcement"
        >
          <v-list-item-action>
            <v-icon>mdi-bullhorn</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              公告
              <v-chip
                v-show="unreadAnnouncementCount"
                class="ml-4 float-right"
                color="red"
                x-small
              >{{unreadAnnouncementCount}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 待辦事項 -->
        <v-list-item
          link
          to="/todo"
          v-if="myLevel >= 10"
        >
          <v-list-item-action>
            <v-icon>mdi-calendar-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              待辦事項
              <v-chip
                v-show="todoBadge.loading || todoBadge.count"
                class="ml-4 float-right sidebar-badge-todo"
                color="red"
                x-small
              >
                <v-progress-circular
                  v-if="todoBadge.loading"
                  indeterminate
                  size="10"
                  width="2"
                  color="white"
                ></v-progress-circular>
                <span v-else>{{todoBadge.count}}</span>
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 工作日誌 -->
        <v-list-item
          link
          to="/work-log"
        >
          <v-list-item-action>
            <v-icon>mdi-math-log</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              工作日誌
              <v-chip
                v-show="workLogBadge.loading || workLogBadge.count"
                class="ml-4 float-right sidebar-badge-worklog"
                color="red"
                x-small
              >
                <v-progress-circular
                  v-if="workLogBadge.loading"
                  indeterminate
                  size="10"
                  width="2"
                  color="white"
                ></v-progress-circular>
                <span v-else>{{workLogBadge.count}}</span>
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 專案 -->
        <v-list-item
          link
          to="/project"
        >
          <v-list-item-action>
            <!-- <v-icon>mdi-blogger</v-icon> -->
            <v-icon>mdi-briefcase</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>專案</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 工單系統 -->
        <v-list-item
          link
          to="/work-order"
          v-if="myLevel != 100"
        >
          <v-list-item-action>
            <v-icon>mdi-badge-account-horizontal-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>工單系統
              <v-chip
                v-show="todoWorkOrderCount"
                class="ml-4 float-right"
                color="red"
                x-small
              >{{todoWorkOrderCount}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 請假管理 -->
        <!-- <v-list-item
          link
          to="/travel"
        >
          <v-list-item-action>
            <v-icon>mdi-airplane-takeoff</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>請假系統
              <v-chip
                v-show="todoLeaveFormCount"
                class="ml-4 float-right"
                color="red"
                x-small
              >{{todoLeaveFormCount}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-list-item
          link
          to="/compensatory-time"
        >
          <v-list-item-action>
            <v-icon>mdi-beach</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>補休天堂
              <v-chip
                v-show="todoCompensatoryTimeCount"
                class="ml-4 float-right"
                color="red"
                x-small
              >{{todoCompensatoryTimeCount}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- 我的獎金 -->
        <v-list-item
          v-if="myLevel<=1"
          link
          to="/me/reward"
        >
          <v-list-item-action>
            <v-icon>mdi-cash-100</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>我的獎金</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-subheader
          v-if="myLevel>=10"
          class="mt-4 grey--text text--darken-1"
        >系統管理</v-subheader>
        <!-- 員工管理 -->
        <v-list-item
          v-if="myLevel>=10"
          link
          to="/management/user"
        >
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>員工管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 客戶管理 -->
        <v-list-item
          v-if="myLevel>=10"
          link
          to="/management/client"
        >
          <v-list-item-action>
            <v-icon>mdi-account-tie</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>客戶管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 部門管理 -->
        <v-list-item
          v-if="myLevel>=10"
          link
          to="/management/department"
        >
          <v-list-item-action>
            <v-icon>mdi-home-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>部門管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 縣市管理 -->
        <v-list-item
          v-if="myLevel>=10"
          link
          to="/management/county"
        >
          <v-list-item-action>
            <v-icon>mdi-island</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>縣市管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-subheader
          v-if="myLevel> 10 || (myLevel == 10 && me.Profile.CanSeeSalary)"
          class="mt-4 grey--text text--darken-1"
        >會計專用</v-subheader>
        <!-- 薪資系統 -->
        <v-list-item
          v-if="myLevel> 10 || (myLevel == 10 && me.Profile.CanSeeSalary)"
          link
          to="/accounting/salary"
        >
          <v-list-item-action>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>薪資系統</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-4 mb-4"></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-information-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>v2.1.3<br><small>2026/09/23</small></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-4 mb-4"></v-divider>

        <v-list-item
          link
          @click="askToLogout"
        >
          <v-list-item-action>
            <v-icon>mdi-power-standby</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      color="black"
      dense
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-img
        class="fill-height logo"
        src="@/assets/logo.png"
      />
      <v-toolbar-title>
        <span class="title custom-title">{{title}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu
        offset-y
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            icon
            v-on="on"
            @click="toggleNotificationCenter"
            class="mr-4"
          >
            <v-badge>
              <template v-slot:badge>{{unreadCount}}</template>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <notification-list />
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <!-- alert -->
    <div
      ref="alertWrapper"
      class="alerts-wrapper"
    >
      <v-alert
        v-for="(alert) in alerts"
        :key="'alert-'+alert.id"
        class="notification"
        :class="{'show': alert.isShow}"
        type="info"
      >
        <span v-html="alert.msg"></span>
        <v-btn
          v-if="!alert.isConfirm"
          color="white"
          text
          @click.stop="removeAlertMessage(alert.id)"
        >
          OK
        </v-btn>
        <v-btn
          v-if="alert.isConfirm"
          color="white"
          text
          @click.stop="removeAlertMessage(alert.id)"
        >
          Close
        </v-btn>
        <v-btn
          v-if="alert.isConfirm"
          color="white"
          text
          @click.stop="alert.onClick"
        >
          OK
        </v-btn>
      </v-alert>
    </div>

    <!-- is loading -->
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

    <!-- all dialog -->
    <task-working-item-detail-dialog
      v-if="$store.state.UI.dialog.taskWorkingItemDetail.isShow"
      v-model="$store.state.UI.dialog.taskWorkingItemDetail.isShow"
      :id="$store.state.UI.dialog.taskWorkingItemDetail.id"
    />
    <work-order-detail-dialog
      v-if="canEditWorkOrder&&$store.state.UI.dialog.workOrderDetail.isShow"
      v-model="$store.state.UI.dialog.workOrderDetail.isShow"
      :id="$store.state.UI.dialog.workOrderDetail.id"
    />
    <leave-form-detail-dialog
      v-if="$store.state.UI.dialog.leaveFormDetail.isShow"
      v-model="$store.state.UI.dialog.leaveFormDetail.isShow"
      :id="$store.state.UI.dialog.leaveFormDetail.id"
    />
    <compensatory-time-detail-dialog
      v-if="$store.state.UI.dialog.compensatoryTimeDetail.isShow"
      v-model="$store.state.UI.dialog.compensatoryTimeDetail.isShow"
      :id="$store.state.UI.dialog.compensatoryTimeDetail.id"
    />
    <salary-detail-dialog
      v-if="$store.state.UI.dialog.salaryDetail.isShow"
      v-model="$store.state.UI.dialog.salaryDetail.isShow"
      :id="$store.state.UI.dialog.salaryDetail.id"
    />
    <project-gantt-dialog
      v-if="$store.state.UI.dialog.projectGantt.isShow"
      v-model="$store.state.UI.dialog.projectGantt.isShow"
      :id="$store.state.UI.dialog.projectGantt.id"
    />

    <project-dialog
      v-if="$store.state.UI.dialog.project.isShow"
      v-model="$store.state.UI.dialog.project.isShow"
      :id="$store.state.UI.dialog.project.id"
      @close="$store.state.UI.dialog.project.isShow=false"
    />

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import {
  countWhere,
  mapTaskDepartmentIds,
  todoNeedsCount,
  workLogNeedsCount
} from "@/utils/chunked-count.js";
import VuetifyAlertMixin from "@/utils/mixin-vuetify+alert.vue";
import NotificationList from "./notification/notification-list.vue";
import swHelper from "@/utils/chrome-webpush-helper.js";
import { resetState } from "@/store";
// dialogs
import TaskWorkingItemDetailDialog from "@/ui/project/task/task-working-item-detail-dialog.vue";
import WorkOrderDetailDialog from "@/ui/work-order/work-order-detail-dialog.vue";
import LeaveFormDetailDialog from "@/ui/leave-form/leave-form-detail-dialog.vue";
import SalaryDetailDialog from "@/ui/accounting/salary-detail-dialog.vue";
import ProjectGanttDialog from "@/ui/project/gantt/project-gantt-dialog.vue";
import CompensatoryTimeDetailDialog from "@/ui/compensatory-time/compensatory-time-detail-dialog.vue";
import ProjectDialog from "@/ui/project/project-dialog.vue";

export default {
  mixins: [VuetifyAlertMixin],
  components: {
    NotificationList,
    /* dialogs */
    TaskWorkingItemDetailDialog,
    WorkOrderDetailDialog,
    LeaveFormDetailDialog,
    SalaryDetailDialog,
    ProjectGanttDialog,
    CompensatoryTimeDetailDialog,
    ProjectDialog
  },
  data: () => ({
    title: "傳動數位設計印刷",
    drawer: null,
    items: [
      { icon: "trending_up", text: "Most Popular" },
      { icon: "subscriptions", text: "Subscriptions" },
      { icon: "history", text: "History" },
      { icon: "featured_play_list", text: "Playlists" },
      { icon: "watch_later", text: "Watch Later" }
    ],
    isLoading: false,
    workLogBadge: { loading: true, count: 0 },
    todoBadge: { loading: true, count: 0 },
    workLogBadgeToken: 0,
    todoBadgeToken: 0
    // alerts
  }),
  computed: {
    unreadAnnouncementCount() {
      return this.$store.state.announcement.list.filter(
        o => !o.ReadedUserIDList || !o.ReadedUserIDList.includes(this.me.ID)
      ).length;
    },
    workLogBadgeSource() {
      const tw = this.$store.state.taskWorkingItem;
      const department = this.$store.getters.myDepartment || {};
      return [
        tw.list.length,
        tw.isFetched,
        tw.isReloaded,
        this.myLevel,
        department.ID
      ].join(":");
    },
    todoBadgeSource() {
      const todo = this.$store.state.todoItem;
      return [todo.list.length, todo.isFetched, todo.isReloaded, this.myLevel].join(":");
    },
    ...mapGetters([
      "me",
      "myLevel",
      "newNotifications",
      "unreadCount",
      "todoWorkOrderCount",
      "todoLeaveFormCount",
      "todoCompensatoryTimeCount",
      "canEditWorkOrder"
    ])
  },
  watch: {
    workLogBadgeSource: {
      immediate: true,
      handler() {
        this.refreshWorkLogBadge();
      }
    },
    todoBadgeSource: {
      immediate: true,
      handler() {
        this.refreshTodoBadge();
      }
    }
  },
  methods: {
    askToLogout() {
      if (confirm("確定登出系統?")) this.logout();
    },
    logout() {
      this.tryUnsubscribe().finally(() => {
        this.$services.auth.logout(this);
        resetState();
        this.$services.reset();
        this.$router.push({ name: "login" });
      });
    },
    toggleNotificationCenter() {
      if (this.unreadCount > 0) {
        let ids = this.newNotifications.filter(o => !o.ViewedAt).map(o => o.ID);
        this.$services.notification.read(this, ids);
        window.bridge.notifyNotificationReaded();
      }
    },
    refreshWorkLogBadge() {
      const token = ++this.workLogBadgeToken;
      this.workLogBadge.loading = true;
      const list = this.$store.state.taskWorkingItem.list;
      const level = this.myLevel || 0;
      const departmentId = (this.$store.getters.myDepartment || {}).ID;
      const tasks = this.$store.state.task.list;
      const isCancelled = () => token !== this.workLogBadgeToken;
      const run = async () => {
        let taskDepartmentById = null;
        if (level == 10) {
          taskDepartmentById = await mapTaskDepartmentIds(tasks, isCancelled);
          if (taskDepartmentById == null) return;
        }
        const count = await countWhere(
          list,
          item => workLogNeedsCount(item, level, departmentId, taskDepartmentById),
          isCancelled
        );
        if (count == null || isCancelled()) return;
        this.workLogBadge.count = count;
        this.workLogBadge.loading = false;
      };
      run();
    },
    refreshTodoBadge() {
      const token = ++this.todoBadgeToken;
      if ((this.myLevel || 0) < 10) {
        this.todoBadge.loading = false;
        this.todoBadge.count = 0;
        return;
      }
      this.todoBadge.loading = true;
      const list = this.$store.state.todoItem.list;
      const isCancelled = () => token !== this.todoBadgeToken;
      countWhere(list, todoNeedsCount, isCancelled).then(count => {
        if (count == null || isCancelled()) return;
        this.todoBadge.count = count;
        this.todoBadge.loading = false;
      });
    },
    tryUnsubscribe() {
      if (!this.$store.state.deviceInfo.subscription) {
        return new Promise((resolve, reject) => resolve());
      }

      let payload = {
        DeviceToken: JSON.stringify(this.$store.state.deviceInfo.subscription),
        DeviceType: "Chrome"
      };
      return this.$services.deviceInfo.unsubscribe(this, payload).then(() => {
        swHelper.unsubscribe();
      });
    }
  },
  created() {
    this.$vuetify.theme.dark = true;

    this.isLoading = true;
    this.$services.prepareDatas(this).finally(() => (this.isLoading = false));
  }
};
</script>

<style>
.v-application .logo {
  height: calc(35px * 5 / 7);
  width: calc(139px * 5 / 7); /* 278 : 70 */
  flex: none;
}
@media screen and (max-width: 399px) {
  .v-application .logo {
    height: calc(35px * 4 / 7);
    width: calc(139px * 4 / 7);
  }
  .v-application .title.custom-title {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 350px) {
  .v-application .logo {
    height: calc(35px * 3 / 7);
    width: calc(139px * 3 / 7);
  }
  .v-application .title.custom-title {
    font-size: 0.9rem !important;
  }
}
@media screen and (max-width: 322px) {
  .v-application .logo {
    height: calc(35px * 2.5 / 7);
    width: calc(139px * 2.5 / 7);
  }
  .v-application .title.custom-title {
    font-size: 0.8rem !important;
  }
}
.v-navigation-drawer {
  height: 100% !important;
}
</style>